import BaseFeature from '../../foundation/base/base';

class Body extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.body = window.features.dom.body;
		this.closeSlider = this.el.querySelector('[data-js="closeSlider"]');
		this.filterInputTrigger = document.querySelector('.m-filter__button');
		this.filterControl = this.el.querySelector('[data-js="filterControl"]');
		this.filterInputScroll = document.getElementById('mFilter');
		this.addClick();
	}

	addClick() {
		// Let the document know when the mouse/key is being used
		this.body.addEventListener('mousedown', () => {
			this.body.classList.add('using-mouse');
		});
		this.body.addEventListener('keydown', () => {
			this.body.classList.remove('using-mouse');
		});

		// Maintain Scroll Position for Filters
		if (this.filterControl) {
			// detect if session value is set
			if (sessionStorage.getItem('targetfilter') === this.filterInputTrigger.value) {
				this.filterInputScroll.scrollIntoView();
			}
			this.filterControl.addEventListener('click', () => {
				// Save the key and value of session storage
				sessionStorage.setItem('targetfilter', this.filterInputTrigger.value);
			});

			// Remove saved data from sessionStorage
			sessionStorage.removeItem('targetfilter');

			// Remove all saved data from sessionStorage
			sessionStorage.clear();
		}
	}
}

export default Body;
